import React from 'react';
import {
  BooleanField,
  ChipField,
  Datagrid,
  DateField,
  TextField,
} from 'react-admin';

export const ReportsDataGrid = () => {
  return (
    <Datagrid>
      <BooleanField source="processed" label="Processed"></BooleanField>
      <ChipField source="type" label="Type"></ChipField>
      <TextField source="description" label="Description" />
      <TextField source="userCreated.nickname" label="Sent by" />
      <DateField source="dateCreated" label="Sent on"></DateField>
    </Datagrid>
  );
};
